import { canv } from "@/canv/global.js";

export class toolBase {
    getToolClass() {
        return `toolBox_${this.name}`;
    }

    getToolView() {
        return "";
    }

    getToolTipName() {
        return "";
    }

    getToolName() {
        return this.name;
    }

    getToolHotKey() {
        return "";
    }

    select() {
        const tool = document.getElementsByClassName(this.getToolClass())[0];
        if (tool === undefined) {
            return;
        }
        tool.classList.add("toolBoxWrapperContentItemSelected");
    }

    unselect() {
        const tool = document.getElementsByClassName(this.getToolClass())[0];
        if (tool === undefined) {
            return;
        }
        tool.classList.remove("toolBoxWrapperContentItemSelected");
    }

    initView() {
        const view = document.getElementsByClassName(this.getToolClass())[0];
        if (view === undefined) return;

        view.addEventListener("mouseup", () => canv.toolBox.switchTo(this), false);
    }

    locateSubMenu(className: string, subMenuClassName: string) {
        const menuItem = document.getElementsByClassName(className)[0];
        if (menuItem === undefined) {
            return;
        }

        const menuSize = menuItem.getBoundingClientRect();

        const subMenu = document.querySelector<HTMLDivElement>(`.${subMenuClassName}`);

        if (subMenu) {
            subMenu.style.top = `${menuSize.top.toString()}px`;
        }
    }

    draw() {}

    name = "";
}
